import { render, staticRenderFns } from "./v-flight-no.vue?vue&type=template&id=53cff30a&scoped=true&"
import script from "./v-flight-no.vue?vue&type=script&lang=js&"
export * from "./v-flight-no.vue?vue&type=script&lang=js&"
import style0 from "./v-flight-no.vue?vue&type=style&index=0&id=53cff30a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cff30a",
  null
  
)

export default component.exports